import { useState, useEffect } from "react";
import {
  EnroleButton,
  HumbergerWrapper,
  NavbarListLi,
  NavbarListUl,
  NavbarListWrapper,
  ScrollLink,
} from "./styles";
import Hamburger from "hamburger-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SpinningIcon } from "../../global_styles/styles";

type NavbarListProps = {
  full: boolean;
};

const NAV_ITEMS = [
  { label: "Results", id: "results", side: "left" },
  { label: "Why us", id: "why-us", side: "left" },
  { label: "Courses", id: "courses", side: "left" },
  { label: "Platform", id: "personal-platform", side: "right" },
  { label: "Teachers", id: "teachers", side: "right" },
  { label: "FAQ", id: "faq", side: "right" },
  {
    label: "Vacancy",
    path: "https://forms.clickup.com/9002212536/f/8c95q5r-36498/2T93PPNS5G6ZVQ4HOU",
    side: "right",
  },
];

const NavbarList: React.FC<NavbarListProps> = ({ full }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setOpen] = useState(false);

  const handleClick = (item: (typeof NAV_ITEMS)[number]) => {
    if (window.innerWidth <= 1024) setOpen(false);

    if (item.path) {
      window.open(item.path, "_blank");
    } else if (item.id) {
      navigate(`/#${item.id}`);
    }
  };

  useEffect(() => {
    if (location.hash) {
      const section = location.hash.replace("#", "");
      const element = document.getElementById(section);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const renderLinks = (side: "left" | "right") => (
    <NavbarListUl
      className={side === "right" ? "!justify-end" : ""}
      full={`${full}`}
    >
      {NAV_ITEMS.filter((item) => item.side === side).map((item) => (
        <NavbarListLi key={item.id || item.path} full={`${full}`}>
          <ScrollLink
            full={`${full}`}
            to={item.id ? `#${item.id}` : item.path!}
            onClick={() => handleClick(item)}
            smooth={!!item.id}
            duration={item.id ? 800 : undefined}
          >
            {item.label}
          </ScrollLink>
        </NavbarListLi>
      ))}
    </NavbarListUl>
  );

  return (
    <div className={full ? "w-full" : ""}>
      {!full && (
        <HumbergerWrapper aria-label="menu">
          <Hamburger toggled={isOpen} toggle={setOpen} />
        </HumbergerWrapper>
      )}

      <NavbarListWrapper open={isOpen} full={full}>
        <div
          className={`flex ${full ? "justify-between" : "flex-col gap-[42px]"}`}
        >
          {renderLinks("left")}
          {renderLinks("right")}
        </div>

        {!full && (
          <Link to="enrole">
            <EnroleButton
              variant="contained"
              onClick={() => setOpen(false)}
              color="secondary"
              endIcon={
                <SpinningIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="29"
                    height="29"
                    viewBox="0 0 29 29"
                    fill="none"
                  >
                    <path
                      d="M21.6148 4.34676L17.317 0L10.3465 7.04996L9.28808 2.98434L3.41874 4.5522L5.94181 14.2189L1.91131 13.116L0.318359 19.0414L9.88678 21.6689L6.92538 24.6424L11.2125 29L18.2257 21.95L19.2948 26.0048L25.1642 24.4262L22.6197 14.7703L26.6502 15.8624L28.2325 9.92617L18.6854 7.33109L21.6361 4.34676H21.6148ZM16.6007 13.1376L21.6468 14.5108L16.6007 15.8732L17.9478 20.9769L14.2701 17.2356L10.5603 20.9661L11.9287 15.8624L6.904 14.4784L11.9287 13.1376L10.6031 8.06636L14.2594 11.7644L17.9478 8.03393L16.6007 13.116V13.1376Z"
                      fill="black"
                    />
                  </svg>
                </SpinningIcon>
              }
            >
              Enroll for a class
            </EnroleButton>
          </Link>
        )}
      </NavbarListWrapper>
    </div>
  );
};

export default NavbarList;
